(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["anchor-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      document.querySelectorAll('.cs-anchors').forEach(initNav);
    }

    function initNav(nav) {
      populateCounts(nav);

      const links = Array.from(nav.querySelectorAll('.cs-anchors__link[href*="#"]'));
      if (!links.length) return;

      const items = links
        .map(function (link) {
          const href = link.getAttribute('href') || '';
          const hashIndex = href.indexOf('#');
          const id = hashIndex >= 0 ? href.slice(hashIndex + 1) : '';
          const target = id ? document.getElementById(id) : null;
          return { link: link, target: target };
        })
        .filter(function (item) { return item.target; });

      if (!items.length) return;

      const offset = parseInt(nav.dataset.scrollOffset, 10) || 100;
      let lockUpdates = false;
      let pendingScrollWaits = 0;

      function setActive(activeItem) {
        items.forEach(function (item) {
          item.link.classList.toggle('is-active', item === activeItem);
        });
      }

      function updateActive() {
        let active = items[0];
        for (let i = 0; i < items.length; i++) {
          const rect = items[i].target.getBoundingClientRect();
          if (rect.top - offset <= 0) {
            active = items[i];
          } else {
            break;
          }
        }
        setActive(active);
      }

      let ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          // Re-check inside the frame: a click may have locked us
          // after this rAF was already scheduled.
          if (lockUpdates) return;
          updateActive();
        });
      }

      function waitForScrollEnd(cb) {
        let done = false;
        function finish() {
          if (done) return;
          done = true;
          cb();
        }
        if ('onscrollend' in window) {
          window.addEventListener('scrollend', function handler() {
            window.removeEventListener('scrollend', handler);
            finish();
          });
          setTimeout(finish, 2000); // safety net
          return;
        }
        // Fallback: poll until scrollY stabilizes
        let lastY = window.scrollY;
        let stable = 0;
        const interval = setInterval(function () {
          if (Math.abs(window.scrollY - lastY) < 1) {
            if (++stable >= 3) {
              clearInterval(interval);
              finish();
            }
          } else {
            stable = 0;
            lastY = window.scrollY;
          }
        }, 100);
        setTimeout(function () {
          clearInterval(interval);
          finish();
        }, 2000);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });

      items.forEach(function (item) {
        item.link.addEventListener('click', function () {
          setActive(item);
          lockUpdates = true;
          pendingScrollWaits++;
          waitForScrollEnd(function () {
            pendingScrollWaits--;
            // Only release once every in-flight scroll has settled,
            // so rapid clicks A→B don't drop the lock mid-scroll.
            if (pendingScrollWaits === 0) lockUpdates = false;
          });
        });
      });

      updateActive();
    }

    function populateCounts(nav) {
      const slots = Array.from(nav.querySelectorAll('[data-cs-count-selector]'));
      if (!slots.length) return;

      function tryFill() {
        let pending = 0;
        slots.forEach(function (slot) {
          if (slot.textContent.trim()) return;
          const sel = slot.getAttribute('data-cs-count-selector');
          let target = null;
          try { target = document.querySelector(sel); } catch (e) { return; }
          const raw = target && target.textContent ? target.textContent.trim() : '';
          if (raw) {
            slot.textContent = raw;
          } else {
            pending++;
          }
        });
        return pending === 0;
      }

      if (tryFill()) return;

      const observer = new MutationObserver(function () {
        if (tryFill()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
      setTimeout(function () { observer.disconnect(); }, 30000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
